// extracted by mini-css-extract-plugin
module.exports = {"main":"_3whUv","doubleCards":"_128lI","reportElement":"_19-Y-","changeBorder1":"cs48W","item":"_1sfTH","card":"_3BJN6"};